import { createIdSlice } from '../utils/action/createElementSlice';
export const MessageState = createIdSlice({
    elementName: 'message',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
    },
});
